import { useContext, useCallback } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import useCart from "./useCart";
import { showSuccess } from "../util/toast";

export const useAuth = () => {
  const {
    isLoggedIn,
    user,
    userInfo,
    setAssistedPurchaseState,
    assistedPurchaseState,
    setUserInfo,
    login: contextLogin,
    logout: contextLogout,
    isCheckingAuth,
  } = useContext(AuthContext);

  const navigate = useNavigate();
  const { dispatch, setClientCartId, setCartId } = useCart();
  const currentUserId = user?.uid || null;

  // Wrapper para login que também limpa o carrinho
  const login = useCallback(
    (uid, token, cashback, is_user_terra, expirationDate) => {
      contextLogin(uid, token, cashback, is_user_terra, expirationDate);
    },
    [contextLogin]
  );

  // Wrapper para logout que também limpa o carrinho e navega
  const logout = useCallback(() => {
    showSuccess("Até logo!");
    if (currentUserId) {
      sessionStorage.removeItem(
        `termsAcceptanceNoNeedsAcceptSessionV3:${String(currentUserId)}`
      );
      // Chaves legadas (podem existir em abas que já testaram versões antigas)
      sessionStorage.removeItem(
        `termsAcceptedSessionV2:${String(currentUserId)}`
      );
      sessionStorage.removeItem(`termsAcceptedSession:${String(currentUserId)}`);
    }
    setClientCartId(null);
    setCartId(null);
    dispatch({ type: "CLEAR" });
    contextLogout();
    navigate("/");
  }, [contextLogout, currentUserId, dispatch, navigate, setCartId, setClientCartId]);

  return {
    login,
    logout,
    userInfo,
    isLoggedIn,
    userId: user?.uid || null,
    token: user?.token || null,
    user,
    setAssistedPurchaseState,
    assistedPurchaseState,
    setUserInfo,
    isCheckingAuth,
  };
};
